
























































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { State, Action, Mutation } from 'vuex-class';
import { IUser } from '~/store/profile/types';
import ProfileProgressIcon from '~/components/Home/ProfileProgressIcon.vue';
import ReferAFriend from '~/components/Share/ReferralDialog.vue';

@Component({
  components: {
    ProfileProgressIcon,
    ReferAFriend,
  },
})
export default class ProfileNavigationDrawer extends Vue {
  @Prop(Boolean) readonly drawerControl!: boolean;

  @State(profile => profile.user, { namespace: 'profile' })
  currentUser!: IUser;
  @State(shareState => shareState.nodesOwned, { namespace: 'share' })
  nodesOwned!: number;

  @Mutation toggleReferralDialog!: (args: any) => void;

  @Action('userLogout', { namespace: 'profile' })
  private userLogout!: () => void;

  nodeLink = process.env.nodeDashboardUrl;
  drawer = false;

  get darkMode() {
    return this.$vuetify.theme.dark;
  }

  get themeChangeText() {
    return this.darkMode ? 'Lights On' : 'Lights Off';
  }

  handleThemeChange() {
    this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
  }

  toggleReferralModal() {
    this.toggleReferralDialog(true);
    this.drawer = false;
  }

  @Watch('drawerControl')
  onDialogChange(val: boolean) {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.drawer = val;
    }
  }

  async handleLogout() {
    await this.userLogout();
  }
}
